import type { AuthError } from '@skytech/auth'
import { useMutation } from '@tanstack/react-query'

import { useTranslation } from '@/app/translations/hooks'
import onboardingResources from '@/forms/onboarding/resources'

const ACCEPTED_FILE_TYPES_DEFAULT = ['doc', 'docx', 'gif', 'jpg', 'jpeg', 'pdf', 'png', 'txt']

const useAuthFilesDropzone = ({
  type,
  fileTypes = ACCEPTED_FILE_TYPES_DEFAULT,
  onUpload,
  onError,
}: {
  type: string
  fileTypes?: string[]
  onUpload?: (file: string) => void
  onError?: (err: string) => void
}) => {
  const translate = useTranslation()

  const uploadAuthorizationMutation = useMutation(
    (file: File) => onboardingResources.uploadAuthorization({ file, type }),
    {
      onSuccess(_res, file) {
        if (onUpload) {
          onUpload(file.name)
        }
      },
      onError(err: AuthError) {
        if (onError) {
          onError(
            err.response.status === 415
              ? translate(
                  'File type not allowed, please use one of the following file types: {fileTypes}',

                  { fileTypes: fileTypes.join(', ') }
                )
              : translate('Something went wrong during upload.')
          )
        }
      },
    }
  )

  return {
    isAuthorizingUpload: uploadAuthorizationMutation.isLoading,
    authorizeUpload: (acceptedFiles: File[]) => {
      uploadAuthorizationMutation.mutate(acceptedFiles[0])
    },
  }
}

export default useAuthFilesDropzone
